<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update']);

const { t } = useI18n();

const data = computed(() => props.data);

const onContentChange = event => {
  emit('update', { content: event.target.value });
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <div class="flex flex-col gap-1.5">
      <label class="text-[11px] font-medium text-n-slate-11">
        {{ t('FLOW_BUILDER.NODE_EDITOR.MESSAGE.CONTENT') }}
      </label>
      <textarea
        :value="data.content || ''"
        :placeholder="t('FLOW_BUILDER.NODE_EDITOR.MESSAGE.CONTENT_PLACEHOLDER')"
        rows="6"
        class="w-full px-3 py-2 text-sm border border-n-weak dark:border-n-strong rounded-lg bg-transparent text-n-slate-12 outline-none focus:border-n-blue-5 resize-none"
        @input="onContentChange"
      />
    </div>
  </div>
</template>
